export const NOTIFICATIONS_FETCH_ERROR =
  'Não conseguimos carregar as notificações :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';

export const OVERVIEW_FETCH_ERROR =
  'Não conseguimos carregar os dados de overview :(<br/>Por favor, tente novamente! Caso o erro persista, entre em contato com nosso suporte pelo chat dentro do sistema.';
